class ProductRecommendationsTabs extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const links = this.querySelectorAll('.product-recommendations__nav-link');
    links.forEach(link => {
      link.addEventListener('click', () => {
        const activeLink = this.querySelector('.product-recommendations__nav-link.active');
        const activeContent = this.querySelector('.product-recommendations__tab-content.active');
        const targetContent = document.querySelector(link.getAttribute('data-target'));

        if (activeLink) {
          activeLink.classList.remove('active');
        }
        if (activeContent) {
          activeContent.classList.remove('active');
        }
        link.classList.add('active');
        targetContent.classList.add('active');
      });
    });
  }
}

customElements.define("w3-product-recommendations-tabs", ProductRecommendationsTabs);
